/**
 * Phase 7 / BR-34: Dismissible info banner.
 * Renders blue info banner with icon, title, message, close button.
 */
import React from "react";
import styles from "./InfoBanner.module.scss";

export interface InfoBannerProps {
  bannerId: string;
  title: string;
  message: string;
  isDismissed: boolean;
  onDismiss: (bannerId: string) => void;
}

const InfoBanner: React.FC<InfoBannerProps> = ({
  bannerId,
  title,
  message,
  isDismissed,
  onDismiss,
}) => {
  if (isDismissed) return null;

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <div className={styles.icon} aria-hidden>
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
            <circle cx="13" cy="13" r="12" stroke="currentColor" strokeWidth="2" />
            <path d="M13 8v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <circle cx="13" cy="18" r="1" fill="currentColor" />
          </svg>
        </div>
        <div className={styles.text}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.message}>{message}</p>
        </div>
        <button
          type="button"
          className={styles.close}
          onClick={() => onDismiss(bannerId)}
          aria-label="Dismiss message"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default InfoBanner;
